// useOrganisationLookup — id → organisation, for admin surfaces that show an
// entity belonging to an org (a unit, an employer user) and want to render that
// org's IDENTITY rather than a generic building glyph (#354).
//
// The lookup is client-side on purpose. AdminContext already loads the full
// organisation list — with logo_url — the moment an admin signs in, so every
// admin surface can resolve an org from an id it already has. The alternative
// was denormalising organisation_name + organisation_logo_url onto the units
// and users responses, which is three more places for the logo to go stale
// after an upload.
import { useMemo } from 'react';
import { useAdmin } from '@/contexts/AdminContext';
import type { OrganisationWithCounts } from '@/lib/models/admin';

export function useOrganisationLookup(): (id?: string | null) => OrganisationWithCounts | undefined {
    const { organisations } = useAdmin();
    const byId = useMemo(() => {
        const m = new Map<string, OrganisationWithCounts>();
        for (const o of organisations) m.set(o.id, o);
        return m;
    }, [organisations]);
    return (id?: string | null) => (id ? byId.get(id) : undefined);
}

export default useOrganisationLookup;
